import { styled } from '@mui/joy';

export const PaymentTable = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
});

export const PaymentTableBody = styled('tbody')({
  ':before': {
    content: '""',
    height: '22px',
    display: 'block',
  },
});
export const PaymentTableHeader = styled('thead')({});
export const PaymentTableHeaderColumn = styled('th')({
  fontWeight: 500,
});
export const PaymentTableColumn = styled('td')({
  fontWeight: 400,
  textAlign: 'center',
  color: '#333',
});

export const PaymentTableRow = styled('tr')({
  fontSize: 15,
  height: '60px',
  background: '#F8F8F8',
  position: 'relative',
  ':not(:last-child):after': {
    content: '""',
    transform: 'translateX(1%)',
    position: 'absolute',
    width: '98%',
    borderBottom: '0.5px solid #D9D9D9;',
    left: 0,
    right: 0,
    bottom: 0,
  },
});
